document.querySelectorAll('.cta-line-account').forEach(button => {
    button.addEventListener('click', function (e) {
        e.preventDefault();

        const rootAttribute = document.querySelector('[data-root]').getAttribute('data-root');

        let fetchUrl = '/pages/external-configurator-account';
        if (rootAttribute && rootAttribute !== '/') {
            fetchUrl = `${rootAttribute}${fetchUrl}`;
        }

        fetch(fetchUrl)
            .then(response => response.text())
            .then(data => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(data, 'text/html');

                const dataExternal = button.getAttribute('data-external');
                const matchingDiv = doc.querySelector(`[data-external="${dataExternal}"] .web-configurator-container`);

                if (matchingDiv) {
                    const modalId = button.dataset.modalTarget;
                    const modal = document.getElementById(modalId);

                    if (modal) {
                        const modalContent = modal.querySelector('.web-configurator-container-tile');
                        if (modalContent) {
                            modalContent.innerHTML = matchingDiv.innerHTML;
                        }
                        modal.style.display = 'flex';
                        document.body.style.overflow = 'hidden';
                        document.documentElement.style.overflow = 'hidden';
                    }
                }
            })
            .catch(error => console.error('Error fetching account data:', error));
    });
});
